/**
 * Uses socket io stream to upload a file in realtime.
 */
export const FILE_UPLOAD_STREAM = 'FILE_UPLOAD_STREAM'
export const FILE_ATTACH_STREAM = 'FILE_ATTACH_STREAM'